import { ReleaseOrdersList } from "../release-orders/components/ReleaseOrdersList";

export const StorageReleaseOrders = () => {
  return <ReleaseOrdersList removalType="GOODS" />;
};
